import { SET_DEFINITION, SET_DEFINITIONS } from "./actions";
import SelectionState from "state/selections/SelectionState";
import { SummaryType } from "@ls/grouping-service";
import { COMMIT_SELECTIONS } from "state/selections/actionTypes";
import {
  RECEIVE_BOOK_BASIS_VALUES,
  RECEIVE_BOOK_ANALYTICS_DATA,
  REQUEST_BOOK_BASIS_VALUES,
  REQUEST_BOOK_ANALYTICS_DATA,
} from "./actions";
import produce from "immer";
import { DELETE_COLUMN } from "state/grid/actions";
import {
  removeDefinitionFromState,
  setDefinitionToState,
} from "state/grid/utils";

const defaultState = {
  definitions: {
    [SelectionState.UNCOMMITTED]: [],
    [SelectionState.COMMITTED]: [],
  },
  fetchingBookBasisValues: false,
  bookBasisValues: [],
  fetchingBookAnalyticsData: {
    [SummaryType.ABSOLUTE]: false,
    [SummaryType.RELATIVE]: false,
  },
  bookAnalyticsData: {
    [SummaryType.ABSOLUTE]: null,
    [SummaryType.RELATIVE]: null,
  },
};

const reducer = produce((state = defaultState, action) => {
  switch (action.type) {
    case SET_DEFINITION: {
      return setDefinitionToState(state, action.idx, action.definition);
    }
    case DELETE_COLUMN: {
      return removeDefinitionFromState(state, action.payload);
    }
    case SET_DEFINITIONS: {
      state.definitions[SelectionState.UNCOMMITTED] = action.definitions;
      break;
    }
    case COMMIT_SELECTIONS: {
      /**reset data before committing to new params**/
      state.bookAnalyticsData = defaultState.bookAnalyticsData;
      state.definitions[SelectionState.COMMITTED] =
        state.definitions[SelectionState.UNCOMMITTED];
      break;
    }
    case REQUEST_BOOK_BASIS_VALUES: {
      state.fetchingBookBasisValues = true;
      state.bookBasisValues = defaultState.bookBasisValues;
      break;
    }
    case RECEIVE_BOOK_BASIS_VALUES: {
      state.fetchingBookBasisValues = false;
      state.bookBasisValues = action.data;
      break;
    }
    case REQUEST_BOOK_ANALYTICS_DATA: {
      state.fetchingBookAnalyticsData[action.summary] = true;
      state.bookAnalyticsData[action.summary] =
        defaultState.bookAnalyticsData[action.summary];
      break;
    }
    case RECEIVE_BOOK_ANALYTICS_DATA: {
      state.fetchingBookAnalyticsData[action.summary] = false;
      state.bookAnalyticsData[action.summary] = action.data;
      break;
    }
    default:
      return state;
  }
});
export default reducer;
